import styled from "styled-components";

const ShowCaseStyled = styled.section`
  max-width: 100%;
  max-height: 600px;
  background-color: ${({ theme }) => theme.color.ash};
  background-image: url(${({ bg }) => bg});
  background-repeat: no-repeat;
  background-size: cover;
  position: relative;
  &::before {
    content: "";
    position: absolute;
    width: 100%;
    background: linear-gradient(
      to top,
      rgba(0, 0, 0, 0.9),
      rgba(0, 0, 0, 0.01)
    );
    height: 200px;
    bottom: 0;
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
    max-width: 100%;
    background-position: center;
    margin-top: 150px;
  }

  .showcase_wrap {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    height: 650px;
    margin-bottom: 100px;
    .text_container {
      line-height: 1.7;
      width: 50%;
      @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
        width: 100%;
      }
      span {
        font-weight: bold;
        color: ${({ theme }) => theme.color.red};
        letter-spacing: 4px;
        @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
          font-size: 1.3rem;
        }
      }
      h1 {
        font-size: 2.3rem;
        color: #fff;
        @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
          font-size: 3rem;
          margin-bottom: 20px;
        }
      }
      a {
        display: inline-block;
        text-decoration: none;
        padding: 10px 20px;
        background-color: ${({ theme }) => theme.color.red};
        border-radius: 5px;
        font-size: 1rem;
        color: #fff;
        font-weight: bold;
        &:hover {
          background-color: transparent;
          border: 1px solid gold;
          color: ${({ theme }) => theme.color.red};
        }
      }
    }
    .appointment {
      display: flex;
      justify-content: space-between;
      align-items: center;
      background-color: ${({ theme }) => theme.color.blue};
      position: absolute;
      bottom: -40px;
      left: 0;
      height: 75px;
      background-color: ${({ theme }) => theme.color.blue};
      color: #fff;
      width: 75%;
      @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
        flex-direction: column;
        background-color: transparent;
        width: 100%;
        height: 120px;
        bottom: -60px;
      }
      .appointment_text {
        display: flex;
        align-items: center;
        font-weight: 400;
        padding-left: 90px;
        @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
          background-color: ${({ theme }) => theme.color.blue};
          /* justify-content: center; */
          width: 100%;
          height: 200px;
          padding-left: 30px;
          font-size: 1.2rem;
        }
        i {
          margin-right: 40px;
          width: 40px;
          height: 40px;
          border-radius: 50%;
          border: 1px solid #fff;
          display: flex;
          justify-content: center;
          align-items: center;
          font-size: 18px;
          @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
            margin-right: 10px;
          
        }
        }
        p {
          span {
            opacity: 0.5;
            font-weight: 400;
          }
        }
      }

      a {
        display: flex;
        justify-content: center;
        align-items: center;
        text-decoration: none;
        padding: 10px 50px;
        background-color: ${({ theme }) => theme.color.red};
        font-size: 0.6rem;
        text-align: center;
        font-weight: bold;
        margin-left: 20px;
        height: 100%;
        font-size: 14px;
        color: #fff;
        &:hover {
          background-color: transparent;
          border: 1px solid ${({ theme }) => theme.color.red};
          color: #fff;
        }
        @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
          width: 100%;
          margin-left: 0;
          /* transform: translateY(50px); */
          font-size: 1.3rem;
        }
      }
    }
  }
`;

export { ShowCaseStyled };
